export enum NavbarPermissions {
  NAV_CASES = 'NAV_CASES',
  NAV_USERS = 'NAV_USERS',
  NAV_INSIGHTS = 'NAV_INSIGHTS',
  NAV_ADMIN = 'NAV_ADMIN',
  NAV_DISCLOSURES = 'NAV_DISCLOSURES',
}
